//? PLUGINS //
import {
    Alert,
    AlertProps,
    Box,
    Card,
    Container,
    Grid,
    GridProps,
    Snackbar,
    SnackbarProps,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import React from "react";

//? STYLES //
import * as Styles from "pages/requests/stepsIndividual/standalone-step0/step0.styles";

//? COMPONENTS //
import PrivacyMessage from "components/messages/privacy-message";
import Content from "./step0.content";

interface Step0Props {
    showMessage: MessageBox;
}

const Step0 = (props: Step0Props) => {
    const { showMessage } = props;
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.between("xs", "lg"));

    React.useEffect(() => {
        setIsOpen(true);
    }, [])

    const SnackbarOptions: SnackbarProps = {
        onClose: () => { setIsOpen(false) },
        open: isOpen,
        sx: Styles.AlertCSS('info').__style,
    };

    const AlertOptions: AlertProps = {
        onClose: () => { setIsOpen(false) },
        variant: "filled",
        sx: Styles.AlertCSS('info').__style,
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                mt: "50px",
                zIndex: '1'
            }}
        >
            {isMobile ? (
                <Content showMessage={showMessage} />
            ) : (
                <Card sx={Styles.cardCSS(theme)}>
                    <Content showMessage={showMessage} />
                </Card>
            )}
            <Snackbar {...SnackbarOptions}>
                <Alert {...AlertOptions}>
                    <PrivacyMessage onClose={() => setIsOpen(false)} />
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default Step0;
